export default "__VITE_ASSET__x1D8zqVZ__"